
    // Define Glbal Mobile
    window.isMobile === false;
    
    jQuery(document).ready(function(){
       
        // Define if on mobile (based on CCS media Queries : Device < 800px wide)
        var resizeTimer;
        LAYOUT.timerResize();
		$(window).resize(function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() { LAYOUT.timerResize() }, 100);
		});
        
        // Wait before images are loaded to launch the first Timer Resize Script
        $('.wrapper').waitForImages(function() {
            // All descendant images have loaded, now slide up.
            LAYOUT.timerResize();
        });
		
		// Style Select Elements
        $('select.subscribe_lang_select').customSelect({customClass:'custom_select_small_grey'});
        
        
        // Click on Mobile Nav
        $('#mobile_nav a').click(function(event){
            // Remove default link action
            event.preventDefault();
            // Toggle Nav
            MOBILE.toggleNav($(this));
        });
        
        // Default Select resize
        AJAXFIX.resizeSelect();

        
    });
    
    
    /* **************************************************************************** */
    /* *************** LAYOUT ******************************************************* */
    /* **************************************************************************** */
    var LAYOUT = {};
	maxHeight = 0;
    LAYOUT.header;
    LAYOUT.isPageReloaded = true;
    LAYOUT.timerCheck;
    LAYOUT.timerResize = function(){

        // Define Element Layout
        LAYOUT.header = $('#header');
        
        // Define if mobile and adjust height of elements
        this.checkMobile();
        this.adjustHeightList();
       
        // Display navigation if not mobile
        if(!window.isMobile){
            MOBILE.showNav();
            this.isPageReloaded = true;
        }else{
            if (this.isPageReloaded){MOBILE.hideNav();}
            this.isPageReloaded = false;
        }
        
        
    };
	
    LAYOUT.checkMobile = function (){
        // Define if on mobile (based on CCS media Queries : Device < 800px wide)
        if ( $("#header").css("position") === 'relative') {
            window.isMobile = true;
        }else{
            window.isMobile = false;
        }
    };
	
    LAYOUT.adjustHeightList = function () {
        // Adjust Height of listings for global listing
        $(".global-list ul li").each(function (){
            var bottom = $(this).find(".listing-bottom");
            bottom.css("height", "auto");
			if(bottom.outerHeight() > maxHeight){
				maxHeight = bottom.outerHeight();
			}
            bottom.css("height", maxHeight+"px"); 
			
        });
    };


    
    /* **************************************************************************** */
    /* *************** MOBILE ******************************************************* */
    /* **************************************************************************** */
    var MOBILE = {};
    MOBILE.toggleNav = function (button){
        var nextAction = button.attr("id");
        if (nextAction === "open_nav"){
            $("#header .region-header").slideDown("fast");
        }else{
            $("#header .region-header").slideUp("fast");
        }
        button.removeClass("active");
        button.siblings().addClass("active");
    };
    MOBILE.showNav = function (){
        $("#header .region-header").show();
        $("#mobile_nav #open_nav").removeClass("active");
        $("#mobile_nav #close_nav").addClass("active");  
		$("select.mobile-nav, .shop-nav .custom_select_black").remove();     
    };
    MOBILE.hideNav = function (){
        $("#header .region-header").hide();
        $("#mobile_nav #open_nav").addClass("active");
        $("#mobile_nav #close_nav").removeClass("active");
		
		$("select.mobile-nav, .shop-nav .custom_select_black").remove();
		
		$(".shop-nav ul").each( function(){
			
			$(this).after('<select class="mobile-nav"><option value="" selected="selected">Select</option></select>');
			
			$(this).find('li').each( function(){
				var val = $(this).find('a').attr('href');
				var title = $(this).find('a').text();
				if( window.location.pathname.indexOf(val) >= 0){
					var selected = 'selected="selected"';
				} else{
					var selected = '';
				}
				
				$(this).parents('ul').next().append('<option value="'+val+'" '+selected+'>'+title+'</option>');
			});

		});
		
		$("select.mobile-nav").change(function(){
			window.location = $(this).attr("value");
		}).customSelect({customClass:'custom_select_black'});

    };
   
   
   
   
   
    /* **************************************************************************** */
    /* *************** AJAXFIX ******************************************************* */
    /* **************************************************************************** */
    // Fix bugs Caused by Ajax loading
    var AJAXFIX = {};
    // Resize select boxes after ajax load for customSelect plugin
    AJAXFIX.resizeSelect = function(){
        $('select.hasCustomSelect').each(function (){
            var customSelectSpan = $(this).next();
            $(this).width(customSelectSpan.outerWidth()).height(customSelectSpan.outerHeight());
        });
    };

        


